import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';
declare var require: any;

@Component({
  selector: 'app-sample-private-file',
  templateUrl: './sample-private-file.component.html',
  styleUrls: ['./sample-private-file.component.scss']
})
export class SamplePrivateFileComponent implements OnInit {

  @Input() block: any;
  @Input() column: any;
  public dataFile: any[] = [];
  public domainWebsite = environment.urlApi;

  constructor() { }

  ngOnInit(): void {
    this.retrieveHrefAndSize();
  }

  private retrieveHrefAndSize(): void {
    if (this.block && this.block.set_file_privati && this.block.set_file_privati.length) {
        const result = [];
        const fileExtensions = ['pdf', 'txt', 'doc', 'xls', 'ppt', 'pps', 'odt', 'ods', 'odp', 'xlsx', 'docx', 'pptx', 'zip', 'rar', 'csv', 'msword'];

        for (const allegato of this.block.set_file_privati) {
            const title = allegato.titolo ? allegato.titolo : undefined;
            const description = allegato.descrizione ? allegato.descrizione : undefined;
            let fileAttachment = allegato.file_privato ? allegato.file_privato : null;    
            let link = '';

            const matches = fileAttachment.match(/<a href="([^"]+)"/);
            if (matches) {
                const href = matches[1];
                const extension = href.split('.').pop();
                if (fileExtensions.includes(extension)) {
                    link = this.domainWebsite + href;
                    fileAttachment = fileAttachment.replace(href, this.domainWebsite + href);
                }
            }

            result.push({
                title,
                description,
                fileAttachment,
                link,
            });
        }

        this.dataFile = result;
    }
  }


}
